import { useState } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  TextField,
} from "@mui/material";

interface YearSelectionModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (year: string) => void;
}

const YearSelectionModal = ({
  open,
  onClose,
  onConfirm,
}: YearSelectionModalProps) => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState<string>(currentYear.toString());

  const handleConfirm = () => {
    onConfirm(selectedYear);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Jahr auswählen</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            select
            label="Jahr"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            fullWidth
            autoFocus
          >
            {Array.from({ length: 10 }, (_, i) => currentYear - i).map((year) => (
              <MenuItem key={year} value={year.toString()}>
                {year}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button onClick={handleConfirm} variant="contained" sx={{ color: "white" }}>
          Weiter
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default YearSelectionModal;
